//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RecipeCalculationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type CreateRecipeCalculationQueryParameters = {
  recipeId: number ;
}

export type UpdateRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
}

export type RemoveRecipeCalculationRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
}

export type GetAllRecipeCalculationQueryParameters = {
  recipeId: number ;
}

export type GetVersionRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
  versionId: number ;
}

export type CalculateBatchRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
  amount?: number | undefined ;
  includeAdditions?: boolean | undefined ;
}

export type MoveRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
  targetRecipeId?: number | undefined ;
  shouldBeCopied?: boolean | undefined ;
}

export type ReorderRecipeCalculationQueryParameters = {
  recipeId: number ;
}

export type SetColorRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
}

export type GetPrintDataRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationId: number ;
  amount?: number | undefined ;
  includeAdditions?: boolean | undefined ;
}

export type GetPrintDataBatchRecipeCalculationQueryParameters = {
  recipeId: number ;
  calculationIds?: number[] | undefined ;
  amount?: number | undefined ;
  includeAdditions?: boolean | undefined ;
}

export type CreateFromLinearBlendRecipeCalculationQueryParameters = {
  recipeId: number ;
}

export type CreateFromTriangleBlendRecipeCalculationQueryParameters = {
  recipeId: number ;
}

export type CreateFromRectangleBlendRecipeCalculationQueryParameters = {
  recipeId: number ;
}

export function calculateOnTheFlyUrl(): string {
  let url_ = getBaseUrl() + "/api/RecipeCalculation/on-the-fly";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function calculateOnTheFlyMutationKey(): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'calculateOnTheFly',
    ]);
}

/**
 * Calculates without saving of result.
 * @param dto Recipe to calculate.
 * @return Dto with result.
 */
export function useCalculateOnTheFlyMutation<TContext>(options?: Omit<UseMutationOptions<Types.RecipeCalculationBaseDto, unknown, Types.CalculateOnTheFlyDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeCalculationBaseDto, unknown, Types.CalculateOnTheFlyDto, TContext> {
  const key = calculateOnTheFlyMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CalculateOnTheFlyDto) => Client.calculateOnTheFly(dto),
    mutationKey: key,
  });
}
  
export function suggestPalettesUrl(): string {
  let url_ = getBaseUrl() + "/api/RecipeCalculation/suggest-palettes";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function suggestPalettesMutationKey(): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'suggestPalettes',
    ]);
}

/**
 * Suggests ranked recipes for a target formula using the requesting user's materials and the
public material library.
 * @param dto Target formula and material availability.
 */
export function useSuggestPalettesMutation<TContext>(options?: Omit<UseMutationOptions<Types.SuggestPalettesResult, unknown, Types.SuggestPalettesDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SuggestPalettesResult, unknown, Types.SuggestPalettesDto, TContext> {
  const key = suggestPalettesMutationKey();

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useMutation({
    ...options,
    mutationFn: (dto: Types.SuggestPalettesDto) => Client.suggestPalettes(dto),
    mutationKey: key,
  });
}

export function getOxideRolesUrl(): string {
  let url_ = getBaseUrl() + "/api/RecipeCalculation/oxide-roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getOxideRolesDefaultOptions: Omit<UseQueryOptions<Types.OxideRoleDto[], unknown, Types.OxideRoleDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.OxideRoleDto[], unknown, Types.OxideRoleDto[]>, 'queryFn'>> = {
};
export function getGetOxideRolesDefaultOptions() {
  return getOxideRolesDefaultOptions;
};
export function setGetOxideRolesDefaultOptions(options: typeof getOxideRolesDefaultOptions) {
  getOxideRolesDefaultOptions = options;
}

export function getOxideRolesQueryKey(): QueryKey;
export function getOxideRolesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'getOxideRoles',
    ]);
}
export function __getOxideRoles(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getOxideRoles(
axiosConfig    );
}

/**
 * Returns the oxide-to-role mapping used by the calculation engine.
Cached by the frontend to drive the WebAssembly calculator.
 * @return List of oxide-to-role mappings.
 */
export function useGetOxideRolesQuery<TSelectData = Types.OxideRoleDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.OxideRoleDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetOxideRolesQuery<TSelectData = Types.OxideRoleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.OxideRoleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.OxideRoleDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getOxideRoles(context, axiosConfig) : __getOxideRoles,
    queryKey: getOxideRolesQueryKey(),
    ...getOxideRolesDefaultOptions as unknown as Omit<UseQueryOptions<Types.OxideRoleDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns the oxide-to-role mapping used by the calculation engine.
Cached by the frontend to drive the WebAssembly calculator.
 * @return List of oxide-to-role mappings.
 */
export function setGetOxideRolesData(queryClient: QueryClient, updater: (data: Types.OxideRoleDto[] | undefined) => Types.OxideRoleDto[], ) {
  queryClient.setQueryData(getOxideRolesQueryKey(),
    updater
  );
}

/**
 * Returns the oxide-to-role mapping used by the calculation engine.
Cached by the frontend to drive the WebAssembly calculator.
 * @return List of oxide-to-role mappings.
 */
export function setGetOxideRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.OxideRoleDto[] | undefined) => Types.OxideRoleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function reduceRecipeTo100Url(): string {
  let url_ = getBaseUrl() + "/api/RecipeCalculation/reduce-to-100";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function reduceRecipeTo100MutationKey(): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'reduceRecipeTo100',
    ]);
}

/**
 * Reduces recipe to 100 without saving of result.
 * @param recipe Recipe to calculate.
 * @return Dto with result.
 */
export function useReduceRecipeTo100Mutation<TContext>(options?: Omit<UseMutationOptions<Types.IngredientDto[], unknown, Types.IngredientForCalculationDto[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IngredientDto[], unknown, Types.IngredientForCalculationDto[], TContext> {
  const key = reduceRecipeTo100MutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (recipe: Types.IngredientForCalculationDto[]) => Client.reduceRecipeTo100(recipe),
    mutationKey: key,
  });
}
  
export function createUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'create',
      recipeId as any,
    ]);
}

/**
 * Creates a new recipe calculation in the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with data for creation.
 * @return Dto with recipe calculation data.
 */
export function useCreateMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<Types.RecipeCalculationDto, unknown, Types.CreateUpdateRecipeCalculationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeCalculationDto, unknown, Types.CreateUpdateRecipeCalculationDto, TContext> {
  const key = createMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateUpdateRecipeCalculationDto) => Client.create(recipeId, dto),
    mutationKey: key,
  });
}
  
type Create__MutationParameters = CreateRecipeCalculationQueryParameters & {
  dto: Types.CreateUpdateRecipeCalculationDto;
}

/**
 * Creates a new recipe calculation in the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with data for creation.
 * @return Dto with recipe calculation data.
 */
export function useCreateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RecipeCalculationDto, unknown, Create__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateRecipeCalculationQueryParameters}): UseMutationResult<Types.RecipeCalculationDto, unknown, Create__MutationParameters, TContext> {
  const key = createMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Create__MutationParameters) => Client.create(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}
  
export function updateUrl(recipeId: number, calculationId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateMutationKey(recipeId: number, calculationId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'update',
      recipeId as any,
      calculationId as any,
    ]);
}

/**
 * Updates the recipe calculation in the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param dto Dto with data for creation.
 * @return Dto with recipe calculation data.
 */
export function useUpdateMutation<TContext>(recipeId: number, calculationId: number, options?: Omit<UseMutationOptions<Types.RecipeCalculationDto, unknown, Types.CreateUpdateRecipeCalculationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeCalculationDto, unknown, Types.CreateUpdateRecipeCalculationDto, TContext> {
  const key = updateMutationKey(recipeId, calculationId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateUpdateRecipeCalculationDto) => Client.update(recipeId, calculationId, dto),
    mutationKey: key,
  });
}
  
type Update__MutationParameters = UpdateRecipeCalculationQueryParameters & {
  dto: Types.CreateUpdateRecipeCalculationDto;
}

/**
 * Updates the recipe calculation in the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param dto Dto with data for creation.
 * @return Dto with recipe calculation data.
 */
export function useUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RecipeCalculationDto, unknown, Update__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateRecipeCalculationQueryParameters}): UseMutationResult<Types.RecipeCalculationDto, unknown, Update__MutationParameters, TContext> {
  const key = updateMutationKey(options?.parameters?.recipeId!, options?.parameters?.calculationId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Update__MutationParameters) => Client.update(data.recipeId ?? options?.parameters?.recipeId!, data.calculationId ?? options?.parameters?.calculationId!, data.dto),
  mutationKey: key,
});
}
  
export function removeRecipeCalculationUrl(recipeId: number, calculationId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeRecipeCalculationMutationKey(recipeId: number, calculationId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'removeRecipeCalculation',
      recipeId as any,
      calculationId as any,
    ]);
}

/**
 * Removes the recipe calculation from the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 */
export function useRemoveRecipeCalculationMutation<TContext>(recipeId: number, calculationId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeRecipeCalculationMutationKey(recipeId, calculationId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeRecipeCalculation(recipeId, calculationId),
    mutationKey: key,
  });
}
  
type RemoveRecipeCalculation__MutationParameters = RemoveRecipeCalculationRecipeCalculationQueryParameters

/**
 * Removes the recipe calculation from the system.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 */
export function useRemoveRecipeCalculationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveRecipeCalculation__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveRecipeCalculationRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, RemoveRecipeCalculation__MutationParameters, TContext> {
  const key = removeRecipeCalculationMutationKey(options?.parameters?.recipeId!, options?.parameters?.calculationId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveRecipeCalculation__MutationParameters) => Client.removeRecipeCalculation(data.recipeId ?? options?.parameters?.recipeId!, data.calculationId ?? options?.parameters?.calculationId!),
  mutationKey: key,
});
}
  
export function getAllUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/all";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllDefaultOptions: Omit<UseQueryOptions<Types.RecipeCalculationDto[], unknown, Types.RecipeCalculationDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RecipeCalculationDto[], unknown, Types.RecipeCalculationDto[]>, 'queryFn'>> = {
};
export function getGetAllDefaultOptions() {
  return getAllDefaultOptions;
};
export function setGetAllDefaultOptions(options: typeof getAllDefaultOptions) {
  getAllDefaultOptions = options;
}

export function getAllQueryKey(recipeId: number): QueryKey;
export function getAllQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId,  } = params[0] as GetAllRecipeCalculationQueryParameters;

    return trimArrayEnd([
        'RecipeCalculationClient',
        'getAll',
        recipeId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeCalculationClient',
        'getAll',
        ...params
      ]);
  }
}
export function __getAll(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAll(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetAllQuery<TSelectData = Types.RecipeCalculationDto[], TError = unknown>(dto: GetAllRecipeCalculationQueryParameters, options?: Omit<UseQueryOptions<Types.RecipeCalculationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets the latest version of recipe calculations.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 */
export function useGetAllQuery<TSelectData = Types.RecipeCalculationDto[], TError = unknown>(recipeId: number, options?: Omit<UseQueryOptions<Types.RecipeCalculationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllQuery<TSelectData = Types.RecipeCalculationDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RecipeCalculationDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId,  } = params[0] as GetAllRecipeCalculationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RecipeCalculationDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAll(context, axiosConfig) : __getAll,
    queryKey: getAllQueryKey(recipeId),
    ...getAllDefaultOptions as unknown as Omit<UseQueryOptions<Types.RecipeCalculationDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets the latest version of recipe calculations.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 */
export function setGetAllData(queryClient: QueryClient, updater: (data: Types.RecipeCalculationDto[] | undefined) => Types.RecipeCalculationDto[], recipeId: number) {
  queryClient.setQueryData(getAllQueryKey(recipeId),
    updater
  );
}

/**
 * Gets the latest version of recipe calculations.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 */
export function setGetAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RecipeCalculationDto[] | undefined) => Types.RecipeCalculationDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getVersionUrl(recipeId: number, calculationId: number, versionId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/version/{versionId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
if (versionId === undefined || versionId === null)
  throw new Error("The parameter 'versionId' must be defined.");
url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getVersionDefaultOptions: Omit<UseQueryOptions<Types.CalculationHistoryRecordDto, unknown, Types.CalculationHistoryRecordDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CalculationHistoryRecordDto, unknown, Types.CalculationHistoryRecordDto>, 'queryFn'>> = {
};
export function getGetVersionDefaultOptions() {
  return getVersionDefaultOptions;
};
export function setGetVersionDefaultOptions(options: typeof getVersionDefaultOptions) {
  getVersionDefaultOptions = options;
}

export function getVersionQueryKey(dto: GetVersionRecipeCalculationQueryParameters): QueryKey;
export function getVersionQueryKey(recipeId: number, calculationId: number, versionId: number): QueryKey;
export function getVersionQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId, calculationId, versionId,  } = params[0] as GetVersionRecipeCalculationQueryParameters;

    return trimArrayEnd([
        'RecipeCalculationClient',
        'getVersion',
        recipeId as any,
        calculationId as any,
        versionId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeCalculationClient',
        'getVersion',
        ...params
      ]);
  }
}
export function __getVersion(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getVersion(
      context.queryKey[2] as number,       context.queryKey[3] as number,       context.queryKey[4] as number,axiosConfig    );
}

export function useGetVersionQuery<TSelectData = Types.CalculationHistoryRecordDto, TError = unknown>(dto: GetVersionRecipeCalculationQueryParameters, options?: Omit<UseQueryOptions<Types.CalculationHistoryRecordDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a specific version of the recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param versionId Version of calculation to return.
 * @return Dto with result.
 */
export function useGetVersionQuery<TSelectData = Types.CalculationHistoryRecordDto, TError = unknown>(recipeId: number, calculationId: number, versionId: number, options?: Omit<UseQueryOptions<Types.CalculationHistoryRecordDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetVersionQuery<TSelectData = Types.CalculationHistoryRecordDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CalculationHistoryRecordDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  let calculationId: any = undefined;
  let versionId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId, calculationId, versionId,  } = params[0] as GetVersionRecipeCalculationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, calculationId, versionId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CalculationHistoryRecordDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getVersion(context, axiosConfig) : __getVersion,
    queryKey: getVersionQueryKey(recipeId, calculationId, versionId),
    ...getVersionDefaultOptions as unknown as Omit<UseQueryOptions<Types.CalculationHistoryRecordDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a specific version of the recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param versionId Version of calculation to return.
 * @return Dto with result.
 */
export function setGetVersionData(queryClient: QueryClient, updater: (data: Types.CalculationHistoryRecordDto | undefined) => Types.CalculationHistoryRecordDto, recipeId: number, calculationId: number, versionId: number) {
  queryClient.setQueryData(getVersionQueryKey(recipeId, calculationId, versionId),
    updater
  );
}

/**
 * Gets a specific version of the recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param versionId Version of calculation to return.
 * @return Dto with result.
 */
export function setGetVersionDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CalculationHistoryRecordDto | undefined) => Types.CalculationHistoryRecordDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function calculateBatchUrl(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/calculate-batch?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
if (amount === null)
    throw new Error("The parameter 'amount' cannot be null.");
else if (amount !== undefined)
    url_ += "amount=" + encodeURIComponent("" + amount) + "&";
if (includeAdditions === null)
    throw new Error("The parameter 'includeAdditions' cannot be null.");
else if (includeAdditions !== undefined)
    url_ += "includeAdditions=" + encodeURIComponent("" + includeAdditions) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let calculateBatchDefaultOptions: Omit<UseQueryOptions<Types.RecipeBatchDto, unknown, Types.RecipeBatchDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RecipeBatchDto, unknown, Types.RecipeBatchDto>, 'queryFn'>> = {
};
export function getCalculateBatchDefaultOptions() {
  return calculateBatchDefaultOptions;
};
export function setCalculateBatchDefaultOptions(options: typeof calculateBatchDefaultOptions) {
  calculateBatchDefaultOptions = options;
}

export function calculateBatchQueryKey(dto: CalculateBatchRecipeCalculationQueryParameters): QueryKey;
export function calculateBatchQueryKey(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined): QueryKey;
export function calculateBatchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId, calculationId, amount, includeAdditions,  } = params[0] as CalculateBatchRecipeCalculationQueryParameters;

    return trimArrayEnd([
        'RecipeCalculationClient',
        'calculateBatch',
        recipeId as any,
        calculationId as any,
        amount as any,
        includeAdditions as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeCalculationClient',
        'calculateBatch',
        ...params
      ]);
  }
}
export function __calculateBatch(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.calculateBatch(
      context.queryKey[2] as number,       context.queryKey[3] as number,       context.queryKey[4] as number | undefined,       context.queryKey[5] as boolean | undefined,axiosConfig    );
}

export function useCalculateBatchQuery<TSelectData = Types.RecipeBatchDto, TError = unknown>(dto: CalculateBatchRecipeCalculationQueryParameters, options?: Omit<UseQueryOptions<Types.RecipeBatchDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Calculates recipe for batch.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function useCalculateBatchQuery<TSelectData = Types.RecipeBatchDto, TError = unknown>(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined, options?: Omit<UseQueryOptions<Types.RecipeBatchDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useCalculateBatchQuery<TSelectData = Types.RecipeBatchDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RecipeBatchDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  let calculationId: any = undefined;
  let amount: any = undefined;
  let includeAdditions: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId, calculationId, amount, includeAdditions,  } = params[0] as CalculateBatchRecipeCalculationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, calculationId, amount, includeAdditions, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RecipeBatchDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __calculateBatch(context, axiosConfig) : __calculateBatch,
    queryKey: calculateBatchQueryKey(recipeId, calculationId, amount, includeAdditions),
    ...calculateBatchDefaultOptions as unknown as Omit<UseQueryOptions<Types.RecipeBatchDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Calculates recipe for batch.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function setCalculateBatchData(queryClient: QueryClient, updater: (data: Types.RecipeBatchDto | undefined) => Types.RecipeBatchDto, recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined) {
  queryClient.setQueryData(calculateBatchQueryKey(recipeId, calculationId, amount, includeAdditions),
    updater
  );
}

/**
 * Calculates recipe for batch.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function setCalculateBatchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RecipeBatchDto | undefined) => Types.RecipeBatchDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function moveUrl(recipeId: number, calculationId: number, targetRecipeId?: number | undefined, shouldBeCopied?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/move?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
if (targetRecipeId === null)
    throw new Error("The parameter 'targetRecipeId' cannot be null.");
else if (targetRecipeId !== undefined)
    url_ += "targetRecipeId=" + encodeURIComponent("" + targetRecipeId) + "&";
if (shouldBeCopied === null)
    throw new Error("The parameter 'shouldBeCopied' cannot be null.");
else if (shouldBeCopied !== undefined)
    url_ += "shouldBeCopied=" + encodeURIComponent("" + shouldBeCopied) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function moveMutationKey(recipeId: number, calculationId: number, targetRecipeId?: number | undefined, shouldBeCopied?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'move',
      recipeId as any,
      calculationId as any,
      targetRecipeId as any,
      shouldBeCopied as any,
    ]);
}

/**
 * Moves the recipe calculation to another recipe.
 * @param recipeId Id of the recipe, where new calculation is located.
 * @param calculationId Id of the recipe calculation.
 * @param targetRecipeId (optional) Recipe Id where the recipe should be moved.
 * @param shouldBeCopied (optional) True if recipe calculator should be copied.
 */
export function useMoveMutation<TContext>(recipeId: number, calculationId: number, targetRecipeId?: number | undefined, shouldBeCopied?: boolean | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = moveMutationKey(recipeId, calculationId, targetRecipeId, shouldBeCopied);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.move(recipeId, calculationId, targetRecipeId, shouldBeCopied),
    mutationKey: key,
  });
}
  
type Move__MutationParameters = MoveRecipeCalculationQueryParameters

/**
 * Moves the recipe calculation to another recipe.
 * @param recipeId Id of the recipe, where new calculation is located.
 * @param calculationId Id of the recipe calculation.
 * @param targetRecipeId (optional) Recipe Id where the recipe should be moved.
 * @param shouldBeCopied (optional) True if recipe calculator should be copied.
 */
export function useMoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Move__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: MoveRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, Move__MutationParameters, TContext> {
  const key = moveMutationKey(options?.parameters?.recipeId!, options?.parameters?.calculationId!, options?.parameters?.targetRecipeId!, options?.parameters?.shouldBeCopied!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Move__MutationParameters) => Client.move(data.recipeId ?? options?.parameters?.recipeId!, data.calculationId ?? options?.parameters?.calculationId!, data.targetRecipeId ?? options?.parameters?.targetRecipeId!, data.shouldBeCopied ?? options?.parameters?.shouldBeCopied!),
  mutationKey: key,
});
}
  
export function reorderUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/reorder";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function reorderMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'reorder',
      recipeId as any,
    ]);
}

/**
 * Applies a user-defined display order to the recipe's calculations.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param dto Ids of the calculations in the desired display order.
 */
export function useReorderMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<void, unknown, Types.ReorderRecipeCalculationsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ReorderRecipeCalculationsDto, TContext> {
  const key = reorderMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ReorderRecipeCalculationsDto) => Client.reorder(recipeId, dto),
    mutationKey: key,
  });
}
  
type Reorder__MutationParameters = ReorderRecipeCalculationQueryParameters & {
  dto: Types.ReorderRecipeCalculationsDto;
}

/**
 * Applies a user-defined display order to the recipe's calculations.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param dto Ids of the calculations in the desired display order.
 */
export function useReorderMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Reorder__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ReorderRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, Reorder__MutationParameters, TContext> {
  const key = reorderMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Reorder__MutationParameters) => Client.reorder(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}
  
export function setColorUrl(recipeId: number, calculationId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/color";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function setColorMutationKey(recipeId: number, calculationId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'setColor',
      recipeId as any,
      calculationId as any,
    ]);
}

/**
 * Sets (or clears) the cosmetic display color of a recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param dto Dto with the color to apply (or null to reset).
 */
export function useSetColorMutation<TContext>(recipeId: number, calculationId: number, options?: Omit<UseMutationOptions<void, unknown, Types.SetCalculationColorDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SetCalculationColorDto, TContext> {
  const key = setColorMutationKey(recipeId, calculationId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.SetCalculationColorDto) => Client.setColor(recipeId, calculationId, dto),
    mutationKey: key,
  });
}
  
type SetColor__MutationParameters = SetColorRecipeCalculationQueryParameters & {
  dto: Types.SetCalculationColorDto;
}

/**
 * Sets (or clears) the cosmetic display color of a recipe calculation.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation.
 * @param dto Dto with the color to apply (or null to reset).
 */
export function useSetColorMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SetColor__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SetColorRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, SetColor__MutationParameters, TContext> {
  const key = setColorMutationKey(options?.parameters?.recipeId!, options?.parameters?.calculationId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SetColor__MutationParameters) => Client.setColor(data.recipeId ?? options?.parameters?.recipeId!, data.calculationId ?? options?.parameters?.calculationId!, data.dto),
  mutationKey: key,
});
}
  
export function getPrintDataUrl(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/{calculationId}/print?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationId === undefined || calculationId === null)
  throw new Error("The parameter 'calculationId' must be defined.");
url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
if (amount === null)
    throw new Error("The parameter 'amount' cannot be null.");
else if (amount !== undefined)
    url_ += "amount=" + encodeURIComponent("" + amount) + "&";
if (includeAdditions === null)
    throw new Error("The parameter 'includeAdditions' cannot be null.");
else if (includeAdditions !== undefined)
    url_ += "includeAdditions=" + encodeURIComponent("" + includeAdditions) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPrintDataDefaultOptions: Omit<UseQueryOptions<Types.PrintRecipeCalculationDto, unknown, Types.PrintRecipeCalculationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PrintRecipeCalculationDto, unknown, Types.PrintRecipeCalculationDto>, 'queryFn'>> = {
};
export function getGetPrintDataDefaultOptions() {
  return getPrintDataDefaultOptions;
};
export function setGetPrintDataDefaultOptions(options: typeof getPrintDataDefaultOptions) {
  getPrintDataDefaultOptions = options;
}

export function getPrintDataQueryKey(dto: GetPrintDataRecipeCalculationQueryParameters): QueryKey;
export function getPrintDataQueryKey(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined): QueryKey;
export function getPrintDataQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId, calculationId, amount, includeAdditions,  } = params[0] as GetPrintDataRecipeCalculationQueryParameters;

    return trimArrayEnd([
        'RecipeCalculationClient',
        'getPrintData',
        recipeId as any,
        calculationId as any,
        amount as any,
        includeAdditions as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeCalculationClient',
        'getPrintData',
        ...params
      ]);
  }
}
export function __getPrintData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPrintData(
      context.queryKey[2] as number,       context.queryKey[3] as number,       context.queryKey[4] as number | undefined,       context.queryKey[5] as boolean | undefined,axiosConfig    );
}

export function useGetPrintDataQuery<TSelectData = Types.PrintRecipeCalculationDto, TError = unknown>(dto: GetPrintDataRecipeCalculationQueryParameters, options?: Omit<UseQueryOptions<Types.PrintRecipeCalculationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data for recipe calculation printing.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function useGetPrintDataQuery<TSelectData = Types.PrintRecipeCalculationDto, TError = unknown>(recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined, options?: Omit<UseQueryOptions<Types.PrintRecipeCalculationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPrintDataQuery<TSelectData = Types.PrintRecipeCalculationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PrintRecipeCalculationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  let calculationId: any = undefined;
  let amount: any = undefined;
  let includeAdditions: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId, calculationId, amount, includeAdditions,  } = params[0] as GetPrintDataRecipeCalculationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, calculationId, amount, includeAdditions, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PrintRecipeCalculationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPrintData(context, axiosConfig) : __getPrintData,
    queryKey: getPrintDataQueryKey(recipeId, calculationId, amount, includeAdditions),
    ...getPrintDataDefaultOptions as unknown as Omit<UseQueryOptions<Types.PrintRecipeCalculationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data for recipe calculation printing.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function setGetPrintDataData(queryClient: QueryClient, updater: (data: Types.PrintRecipeCalculationDto | undefined) => Types.PrintRecipeCalculationDto, recipeId: number, calculationId: number, amount?: number | undefined, includeAdditions?: boolean | undefined) {
  queryClient.setQueryData(getPrintDataQueryKey(recipeId, calculationId, amount, includeAdditions),
    updater
  );
}

/**
 * Gets data for recipe calculation printing.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param calculationId Id of the recipe calculation for batch.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return Dto with result.
 */
export function setGetPrintDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PrintRecipeCalculationDto | undefined) => Types.PrintRecipeCalculationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getPrintDataBatchUrl(recipeId: number, calculationIds?: number[] | undefined, amount?: number | undefined, includeAdditions?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/print-batch?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (calculationIds === null)
    throw new Error("The parameter 'calculationIds' cannot be null.");
else if (calculationIds !== undefined)
    calculationIds && calculationIds.forEach(item => { url_ += "calculationIds=" + encodeURIComponent("" + item) + "&"; });
if (amount === null)
    throw new Error("The parameter 'amount' cannot be null.");
else if (amount !== undefined)
    url_ += "amount=" + encodeURIComponent("" + amount) + "&";
if (includeAdditions === null)
    throw new Error("The parameter 'includeAdditions' cannot be null.");
else if (includeAdditions !== undefined)
    url_ += "includeAdditions=" + encodeURIComponent("" + includeAdditions) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPrintDataBatchDefaultOptions: Omit<UseQueryOptions<Types.PrintRecipeCalculationDto[], unknown, Types.PrintRecipeCalculationDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PrintRecipeCalculationDto[], unknown, Types.PrintRecipeCalculationDto[]>, 'queryFn'>> = {
};
export function getGetPrintDataBatchDefaultOptions() {
  return getPrintDataBatchDefaultOptions;
};
export function setGetPrintDataBatchDefaultOptions(options: typeof getPrintDataBatchDefaultOptions) {
  getPrintDataBatchDefaultOptions = options;
}

export function getPrintDataBatchQueryKey(dto: GetPrintDataBatchRecipeCalculationQueryParameters): QueryKey;
export function getPrintDataBatchQueryKey(recipeId: number, calculationIds?: number[] | undefined, amount?: number | undefined, includeAdditions?: boolean | undefined): QueryKey;
export function getPrintDataBatchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId, calculationIds, amount, includeAdditions,  } = params[0] as GetPrintDataBatchRecipeCalculationQueryParameters;

    return trimArrayEnd([
        'RecipeCalculationClient',
        'getPrintDataBatch',
        recipeId as any,
        calculationIds as any,
        amount as any,
        includeAdditions as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeCalculationClient',
        'getPrintDataBatch',
        ...params
      ]);
  }
}
export function __getPrintDataBatch(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPrintDataBatch(
      context.queryKey[2] as number,       context.queryKey[3] as number[] | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as boolean | undefined,axiosConfig    );
}

export function useGetPrintDataBatchQuery<TSelectData = Types.PrintRecipeCalculationDto[], TError = unknown>(dto: GetPrintDataBatchRecipeCalculationQueryParameters, options?: Omit<UseQueryOptions<Types.PrintRecipeCalculationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data for printing multiple recipe calculations in one call.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param calculationIds (optional) Ids of the recipe calculations to print.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return List of dtos with results, one per requested calculation.
 */
export function useGetPrintDataBatchQuery<TSelectData = Types.PrintRecipeCalculationDto[], TError = unknown>(recipeId: number, calculationIds?: number[] | undefined, amount?: number | undefined, includeAdditions?: boolean | undefined, options?: Omit<UseQueryOptions<Types.PrintRecipeCalculationDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPrintDataBatchQuery<TSelectData = Types.PrintRecipeCalculationDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PrintRecipeCalculationDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  let calculationIds: any = undefined;
  let amount: any = undefined;
  let includeAdditions: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId, calculationIds, amount, includeAdditions,  } = params[0] as GetPrintDataBatchRecipeCalculationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, calculationIds, amount, includeAdditions, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PrintRecipeCalculationDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPrintDataBatch(context, axiosConfig) : __getPrintDataBatch,
    queryKey: getPrintDataBatchQueryKey(recipeId, calculationIds, amount, includeAdditions),
    ...getPrintDataBatchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PrintRecipeCalculationDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data for printing multiple recipe calculations in one call.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param calculationIds (optional) Ids of the recipe calculations to print.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return List of dtos with results, one per requested calculation.
 */
export function setGetPrintDataBatchData(queryClient: QueryClient, updater: (data: Types.PrintRecipeCalculationDto[] | undefined) => Types.PrintRecipeCalculationDto[], recipeId: number, calculationIds?: number[] | undefined, amount?: number | undefined, includeAdditions?: boolean | undefined) {
  queryClient.setQueryData(getPrintDataBatchQueryKey(recipeId, calculationIds, amount, includeAdditions),
    updater
  );
}

/**
 * Gets data for printing multiple recipe calculations in one call.
 * @param recipeId Id of the recipe to which the recipe calculations belong to.
 * @param calculationIds (optional) Ids of the recipe calculations to print.
 * @param amount (optional) Final amount of glaze after mixing.
 * @param includeAdditions (optional) Shows whether additional ingredients should be included into amount.
 * @return List of dtos with results, one per requested calculation.
 */
export function setGetPrintDataBatchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PrintRecipeCalculationDto[] | undefined) => Types.PrintRecipeCalculationDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createFromLinearBlendUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/linear-blend";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createFromLinearBlendMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'createFromLinearBlend',
      recipeId as any,
    ]);
}

/**
 * Calculates point in a linear blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function useCreateFromLinearBlendMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<void, unknown, Types.CalculateLinearBlend, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CalculateLinearBlend, TContext> {
  const key = createFromLinearBlendMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CalculateLinearBlend) => Client.createFromLinearBlend(recipeId, dto),
    mutationKey: key,
  });
}
  
type CreateFromLinearBlend__MutationParameters = CreateFromLinearBlendRecipeCalculationQueryParameters & {
  dto: Types.CalculateLinearBlend;
}

/**
 * Calculates point in a linear blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function useCreateFromLinearBlendMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CreateFromLinearBlend__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateFromLinearBlendRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, CreateFromLinearBlend__MutationParameters, TContext> {
  const key = createFromLinearBlendMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CreateFromLinearBlend__MutationParameters) => Client.createFromLinearBlend(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}
  
export function createFromTriangleBlendUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/triangle-blend";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createFromTriangleBlendMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'createFromTriangleBlend',
      recipeId as any,
    ]);
}

/**
 * Calculates point in a triangle blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function useCreateFromTriangleBlendMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<void, unknown, Types.CalculateTriangleBlendDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CalculateTriangleBlendDto, TContext> {
  const key = createFromTriangleBlendMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CalculateTriangleBlendDto) => Client.createFromTriangleBlend(recipeId, dto),
    mutationKey: key,
  });
}
  
type CreateFromTriangleBlend__MutationParameters = CreateFromTriangleBlendRecipeCalculationQueryParameters & {
  dto: Types.CalculateTriangleBlendDto;
}

/**
 * Calculates point in a triangle blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function useCreateFromTriangleBlendMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CreateFromTriangleBlend__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateFromTriangleBlendRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, CreateFromTriangleBlend__MutationParameters, TContext> {
  const key = createFromTriangleBlendMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CreateFromTriangleBlend__MutationParameters) => Client.createFromTriangleBlend(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}
  
export function createFromRectangleBlendUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/RecipeCalculation/rectangle-blend";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createFromRectangleBlendMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'RecipeCalculationClient',
      'createFromRectangleBlend',
      recipeId as any,
    ]);
}

/**
 * Calculates point in a rectangle blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function useCreateFromRectangleBlendMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<void, unknown, Types.CalculateRectangleBlendDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CalculateRectangleBlendDto, TContext> {
  const key = createFromRectangleBlendMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CalculateRectangleBlendDto) => Client.createFromRectangleBlend(recipeId, dto),
    mutationKey: key,
  });
}
  
type CreateFromRectangleBlend__MutationParameters = CreateFromRectangleBlendRecipeCalculationQueryParameters & {
  dto: Types.CalculateRectangleBlendDto;
}

/**
 * Calculates point in a rectangle blend and creates a recipe calculation with result in the recipe.
 * @param recipeId Id of the recipe to which the recipe calculation belongs to.
 * @param dto Dto with necessary data for blend calculation.
 */
export function useCreateFromRectangleBlendMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, CreateFromRectangleBlend__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateFromRectangleBlendRecipeCalculationQueryParameters}): UseMutationResult<void, unknown, CreateFromRectangleBlend__MutationParameters, TContext> {
  const key = createFromRectangleBlendMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CreateFromRectangleBlend__MutationParameters) => Client.createFromRectangleBlend(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}